// El estado ENVIADA se debe borrar cuando se limpie la bbdd
const ESTADO_DENUNCIA = {
  ABIERTA: 'ABIERTA',
  ENPROCESO: 'ENPROCESO',
  PENDIENTERESPUESTA: 'PENDIENTERESPUESTA',
  FINALIZADA: 'FINALIZADA',
  DESESTIMADA: 'DESESTIMADA',
  ENVIADA: 'ENVIADA',
};

const ESTADOS_DENUNCIA = {
  [ESTADO_DENUNCIA.ABIERTA]: {
    desc: 'Abierta',
    color: 'blue',
  },
  [ESTADO_DENUNCIA.ENPROCESO]: {
    desc: 'En proceso',
    color: 'orange',
  },
  [ESTADO_DENUNCIA.PENDIENTERESPUESTA]: {
    desc: 'Pendiente de respuesta',
    color: 'red',
  },
  [ESTADO_DENUNCIA.FINALIZADA]: {
    desc: 'Finalizada',
    color: 'green',
  },
  [ESTADO_DENUNCIA.DESESTIMADA]: {
    desc: 'Desestimada',
    color: 'gray',
  },
  [ESTADO_DENUNCIA.ENVIADA]: {
    desc: 'Enviada',
    color: 'blue',
  },
};

export { ESTADOS_DENUNCIA, ESTADO_DENUNCIA };
